import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Sidebar from "../../components/common/Sidebar";
import Navbar from "../../components/common/Navbar";

import {
  createLeadApi,
  getLeadsApi,
  updateLeadStatusApi,
  assignLeadApi
} from "../../services/leadsApi";

import "./Leads.css";

const LeadsManagement = () => {

  const navigate = useNavigate();

  const [form, setForm] = useState({
    shop_name: "",
    owner_name: "",
    phone: "",
    city: "",
    state: ""
  });

  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.role;

  // =========================
  // INPUT
  // =========================
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // =========================
  // CREATE LEAD
  // =========================
  const handleCreate = async () => {
    try {
      setLoading(true);

      const payload = {
        ...form,
        lead_code: "LD-" + Date.now()
      };

      const res = await createLeadApi(payload);

      alert("✅ Lead Created");

      setLeads((prev) => [res.data.lead, ...prev]);

      setForm({
        shop_name: "",
        owner_name: "",
        phone: "",
        city: "",
        state: ""
      });

    } catch (err) {
      alert(err?.response?.data?.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // FETCH LEADS (FIXED)
  // =========================
  const fetchLeads = async () => {
    try {
      const res = await getLeadsApi();

      // 🔥 FIX: ensure stable array + no overwrite bug
      const data = Array.isArray(res.data) ? res.data : [];

      setLeads([...data]);

    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  // =========================
  // STATUS UPDATE
  // =========================
  const handleStatusChange = async (id, status) => {
    try {
      await updateLeadStatusApi(id, { status });

      setLeads((prev) =>
        prev.map((l) =>
          l.id === id ? { ...l, status } : l
        )
      );
    } catch (err) {
      alert("Error updating status");
    }
  };

  // =========================
  // ASSIGN (ADMIN ONLY)
  // =========================
  const handleAssign = async (e, id) => {
    e.stopPropagation();

    if (role !== "admin") return;

    const email = prompt("Enter Active Staff Email");
    if (!email) return;

    try {
      await assignLeadApi(id, email);

      alert("✅ Assigned");

      // 🔥 FIX: avoid race condition
      setTimeout(() => {
        fetchLeads();
      }, 150);

    } catch (err) {
      alert("Error assigning");
    }
  };

  return (
    <div className={role === "admin" ? "admin-container" : "staff-container"}>

      {role === "admin" && <Sidebar role={role} />}

      <div className={role === "admin" ? "admin-main" : "staff-main"}>

        {role === "admin" && <Navbar />}

        <div className="admin-content">

          <h2>📊 Leads Management</h2>

          <div className="lead-box">
            <h3>Create Lead</h3>

            <div className="lead-form">
              <input name="shop_name" placeholder="Shop Name" value={form.shop_name} onChange={handleChange} />
              <input name="owner_name" placeholder="Owner Name" value={form.owner_name} onChange={handleChange} />
              <input name="phone" placeholder="Phone" value={form.phone} onChange={handleChange} />
              <input name="city" placeholder="City" value={form.city} onChange={handleChange} />
              <input name="state" placeholder="State" value={form.state} onChange={handleChange} />

              <button onClick={handleCreate} disabled={loading}>
                ➕ Create Lead
              </button>
            </div>
          </div>

          <div className="lead-box">
            <h3>Leads List</h3>

            <table className="lead-table">
              <thead>
                <tr>
                  <th>Shop</th>
                  <th>Owner</th>
                  <th>Phone</th>
                  <th>Status</th>
                  <th>City</th>

                  {role === "admin" && <th>Assign</th>}

                  <th>Activity</th>
                </tr>
              </thead>

              <tbody>
                {leads.map((lead) => (
                  <tr
                    key={lead.id}
                    onClick={() => navigate(`/${role}/leads/${lead.id}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <td>{lead.shop_name}</td>
                    <td>{lead.owner_name}</td>
                    <td>{lead.phone}</td>

                    <td onClick={(e) => e.stopPropagation()}>
                      <select
                        value={lead.status}
                        onChange={(e) =>
                          handleStatusChange(lead.id, e.target.value)
                        }
                      >
                        <option value="NEW">NEW</option>
                        <option value="CONTACTED">CONTACTED</option>
                        <option value="FOLLOWUP">FOLLOWUP</option>
                        <option value="CLOSED">CLOSED</option>
                      </select>
                    </td>

                    <td>{lead.city}</td>

                    {role === "admin" ? (
                      <td onClick={(e) => e.stopPropagation()}>
                        <button onClick={(e) => handleAssign(e, lead.id)}>
                          Assign
                        </button>
                      </td>
                    ) : null}

                    <td onClick={(e) => e.stopPropagation()}>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/${role}/leads/${lead.id}/activity`);
                        }}
                      >
                        Activity
                      </button>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>

          </div>

        </div>
      </div>
    </div>
  );
};

export default LeadsManagement;